export const PATHS = {
    ROOT: 'settings',
    PARAMETERS: 'parameters',
    CURRENCY: 'currency',
    CURRENCIES: 'currencies',
}